export class AppConstants {
  public static readonly CIM_COMPANY_NAME = 'CIM';
  public static readonly DEFAULT_TITLE = 'PEAK';
  public static readonly DEFAULT_LOGO_HEIGHT_PX = 40;
  public static readonly DEFAULT_LOGO_WIDTH_PX = 90;
  public static readonly DEFAULT_LOGO_DIMENSION = this.DEFAULT_LOGO_WIDTH_PX + 'x' + this.DEFAULT_LOGO_HEIGHT_PX;
  public static readonly DEFAULT_LOGO_URLS = {
    default: '/assets/images/cim-logo-small.png',
    [this.DEFAULT_LOGO_DIMENSION]: '/assets/images/cim-logo-small-' + this.DEFAULT_LOGO_DIMENSION + '.png'
  };
  public static readonly MAIN_CONTAINER_CLASS_NAME = 'main-container';
  /** id of the app-shell div (src/index.html) that select panels are appended to so they are not clipped by overflow containers. */
  public static readonly DROPDOWN_HOLDER_ID = 'dropdownHolder';
  public static readonly DROPDOWN_HOLDER_SELECTOR = '#' + this.DROPDOWN_HOLDER_ID;
  public static readonly DEFAULT_LOGO_FONT_SIZE = this.DEFAULT_LOGO_HEIGHT_PX + 'px';
  public static readonly DEFAULT_COMMENT_LOGO_FONT_SIZE = '20px';
  public static readonly DEFAULT_LOGO_CONTAINER_WIDTH = '50px';
  public static readonly DEFAULT_CHART_HEIGHT_PIXELS = 350;
  public static readonly DEFAULT_CHART_HEIGHT = AppConstants.DEFAULT_CHART_HEIGHT_PIXELS + 'px';
  public static readonly RESIZE_EVENT_DEBOUNCE_MS = 200;
  public static readonly INPUT_ASYNC_VALIDATOR_DEBOUNCE_MS = 1000;

  public static readonly TICKET_SEARCH_PARAM_NAME_RESOLVE_ASSOCIATED_SITES = 'associated_sites';

  public static readonly UTC_TIMEZONE = 'utc';
  public static readonly MONTH_FORMAT = 'MMM yyyy';
  public static readonly DATE_FORMAT = 'YYYY-MM-DD';
  public static readonly TIMESTAMP_TIME_FORMAT = 'HH:mm:ss.SSS';
  public static readonly TIMESTAMP_FORMAT = this.DATE_FORMAT + 'T' + this.TIMESTAMP_TIME_FORMAT;
  public static readonly TIMESTAMP_FORMAT_MINUTE_PRECISION_MOMENT = 'DD MMM yyyy HH:mm';
  public static readonly DATE_PIPE_DISPLAY_FORMAT = 'D MMM YYYY';
  public static readonly TIME_FORMAT_SECOND_PRECISION = 'YYYY-MM-DD HH:mm:ss';
  public static readonly TIME_FORMAT_MINUTE_PRECISION = 'YYYY-MM-DD HH:mm';
  public static readonly SCORE_CARD_LOADING_PLACEHOLDER = '?';
  public static readonly SCORE_CARD_EMPTY_PLACEHOLDER = '-';

  public static readonly SCORE_PERCENT_FORMAT = '1.0-0';

  public static readonly PORTFOLIO_SITE_PHOTO_DISPLAY_RATIO = 4 / 3;
  public static readonly PORTFOLIO_SITE_PHOTO_DISPLAY_WIDTH_PX = 260;
  public static readonly PORTFOLIO_SITE_PHOTO_DISPLAY_HEIGHT_PX = AppConstants.PORTFOLIO_SITE_PHOTO_DISPLAY_WIDTH_PX / AppConstants.PORTFOLIO_SITE_PHOTO_DISPLAY_RATIO;

  public static readonly DEFAULT_TARGET_PASS_RATE = 0.97;

  /** Limit of count of tickets that can be exported at one time. The request starts to get an error response around 13000. Settled on 10,000 which is large enough. */
  public static readonly TICKET_EXPORT_LIMIT = 10000;

  public static readonly URL_CHAR_LIMIT = 10000;

  /** Fixed BACnet protocol device-ID bounds. Max is 4194302 because 4194303 (the 22-bit max) is reserved by the spec for uninitialized devices. */
  public static readonly MIN_BACNET_DEVICE_ID = 0;
  public static readonly MAX_BACNET_DEVICE_ID = 4194302;

  public static readonly INDICATOR_COLORS = {
    RED: '#EB4241',
    ORANGE: '#FFB48A',
    YELLOW: '#F6C344',
    GREEN: '#21BF74',
    GREY: '#ADB5BD',
    LIGHT_GREY: '#E9ECEF',
    TRANSPARENT: 'transparent'
  } as const;
}

export type IndicatorColor = (typeof AppConstants.INDICATOR_COLORS)[keyof typeof AppConstants.INDICATOR_COLORS];
